export const FREQUENCY_OPTIONS = [
  { key: "month", value: "month", text: "Monthly" },
  { key: "quarter", value: "quarter", text: "Quarterly" },
  { key: "semi-annual", value: "semi-annual", text: "Semi-Annually" },
  { key: "year", value: "year", text: "Annually" }
];

export const ACCRUAL_OPTIONS = [
  { key: "actual_actual", value: "actual_actual", text: "Actual/Actual" },
  { key: "actual_360", value: "actual_360", text: "Actual/360" },
  { key: "actual_365", value: "actual_365", text: "Actual/365" },
  { key: "30_360", value: "30_360", text: "30/360" }
];

export const FREQ_LABELS: Record<string, string> = {
  month: "Monthly",
  quarter: "Quarterly",
  "semi-annual": "Semi-Annually",
  year: "Annually"
};

// Step IDs — sequential 0–9
// 0: Debt Configuration
// 1: Principal Repayment Setup
// 2: Interest Type
// 3: Interest Rate Terms
// 4: PIK Interest Terms
// 5: Arrangement Fees
// 6: Review & Confirm Facility
// 7: First Drawdown
// 8: Review & Confirm Drawdown
// 9: All Done!
export const STEP_META: Record<number, { title: string; subtitle: string }> = {
  0: {
    title: "Debt Configuration",
    subtitle: "Define the core structure and key financial terms of your debt instrument"
  },
  1: {
    title: "Principal Repayment Setup",
    subtitle: "Specify how and when the principal amount will be repaid"
  },
  2: {
    title: "Interest Type",
    subtitle: "Select what kind of interest this debt carries"
  },
  3: {
    title: "Interest Rate Terms",
    subtitle: "Configure the interest structure, rates, and payment schedule"
  },
  4: {
    title: "PIK Interest Terms",
    subtitle: "Set up the Payment-In-Kind interest that accrues and capitalizes over time"
  },
  5: {
    title: "Arrangement Fees",
    subtitle: "Add any upfront or ongoing fees associated with this credit facility"
  },
  6: {
    title: "Review & Confirm Facility",
    subtitle: "Review the facility terms carefully before creating"
  },
  7: {
    title: "First Drawdown",
    subtitle: "Set up the initial drawdown on this credit facility"
  },
  8: {
    title: "Review & Confirm Drawdown",
    subtitle: "Confirm the details of your first drawdown before creating"
  },
  9: {
    title: "All Done!",
    subtitle: ""
  }
};
